import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import NetworkController from "../../shared/NetworkController";
import { colors } from "../../theme/palette";
import Trending from "../../shared/Trending";
import {
  TrendingProfessionalsIcon,
  TrendingTalentsIcon,
  TrendingEntitiesIcon,
} from "../../assets/icons/MUI/NetworkIcons";
import { getTrendingProfessionals, getTrendingTalents, getTrendingEntities } from "../../api/network";

const Network = () => {
  const { t } = useTranslation();

  const { data: trendingTalents, isLoading: isTrendingTalentsLoading } = useQuery({
    queryKey: ["trendingTalents"],
    queryFn: async () => await getTrendingTalents(),
  });

  const { data: trendingProfessionals, isLoading: isTrendingProfessionalsLoading } = useQuery({
    queryKey: ["trendingProfessionals"],
    queryFn: async () => await getTrendingProfessionals(),
  });

  const { data: trendingEntities, isLoading: isTrendingEntitiesLoading } = useQuery({
    queryKey: ["trendingEntities"],
    queryFn: async () => await getTrendingEntities(),
  });

  return (
    <Box sx={styles.container}>
      <Box sx={styles.networkControllerContainer}>
        <NetworkController isOwnNetworkTab={true} />
      </Box>
      <Box sx={styles.trendingContainer}>
        <Trending
          icon={<TrendingTalentsIcon />}
          label={t("components.trending.talents")}
          users={trendingTalents}
          isLoading={isTrendingTalentsLoading}
          query="talents"
          sum={true}
        />
        <Trending
          icon={<TrendingProfessionalsIcon />}
          label={t("components.trending.professionals")}
          users={trendingProfessionals}
          isLoading={isTrendingProfessionalsLoading}
          query="professionals"
        />
        <Trending
          icon={<TrendingEntitiesIcon />}
          label={t("components.trending.entities")}
          users={trendingEntities}
          isLoading={isTrendingEntitiesLoading}
          query="entities"
          sum={true}
        />
      </Box>
    </Box>
  );
};

export default Network;

const styles = {
  container: {
    display: "flex",
    gap: "15px",
  },
  networkControllerContainer: {
    padding: "12px",
    background: colors.White,
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    // width: "555px",
    width: { xs: "100%", lg: "555px" },
    overflow: "hidden",
    height: "fit-content",
  },
  trendingContainer: { display: { xs: "none", md: "flex" }, flexDirection: "column", gap: "14px" },
};
